import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getMAGAT020, postMAGAT020, putMAGAT020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS, MESSAGE } from '../../../shared/constants/app';
import { handleFocus } from '../../../utils';

const MAGAT020 = () => {
    const { id } = useParams();
    const [data, setData] = useState({ type: 'WP' });
    const [dspYN, setDspYN] = useState('');
    const [fileName, setFileName] = useState(null);
    const [file, setFile] = useState(null);
    const navigate = useNavigate();

    const handleSave = () => {
        if (!data?.title || data?.title.trim() === '') {
            window.alert('교육명은 필수 입력 항목입니다.');
            handleFocus('title');
            return;
        }
        if (!data?.content || data?.content.trim() === '') {
            window.alert('내용은 필수 입력 항목입니다.');
            handleFocus('contentTextarea');
            return;
        }
        // if (!fileName) {
        //     window.alert('교육자료는 필수 첨부 항목입니다.');
        //     handleFocus('file-input');
        //     return;
        // }
        // if (!data?.url || data?.url.trim() === '') {
        //     window.alert('링크는 필수 입력 항목입니다.');
        //     handleFocus('url');
        //     return;
        // }
        if (!dspYN) {
            window.alert('공개여부를 선택해 주세요.');
            handleFocus('dspYN');
            return;
        }
        const payload = {
            type: data?.type || 'WP',
            title: data?.title,
            content: data?.content,
            agency: data?.agency,
            url: data?.url,
            urlTitle: data?.urlTitle,
            ord: data?.ord,
            dspYN: dspYN,
        };
        if (id) {
            payload.seq = id;
        } else {
            payload.addDate = moment().format('YYYY-MM-DDTHH:mm:ss.SSS');
        }
        const formData = new FormData();
        formData.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));

        if (file) {
            formData.append('file', file);
        }
        const isConfirmed = window.confirm('등록/수정하시겠습니까?');
        const apiCall = id ? putMAGAT020 : postMAGAT020;
        const message = '등록/수정되었습니다.';

        if (isConfirmed) {
            apiCall(formData)
                .then(() => {
                    window.alert(message);
                    navigate('/magat010');
                })
                .catch((error) => {
                    console.log(error);
                    window.alert(MESSAGE.notify.updateError);
                });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile?.size === 0) {
            window.alert('0바이드 파일을 업로드할 수 없습니다.');
            return;
        }

        if (selectedFile?.size > 1073741824) {
            window.alert('파일용량은 1Gb 이하만 가능합니다.');
            return;
        }
        if (selectedFile) {
            const fileSelected = selectedFile?.name;
            setFileName(fileSelected);
            setFile(selectedFile);
        } else {
            setFileName(null);
            setFile(null);
        }
    };

    const handleChangeDsp = (e) => {
        const value = e.target.value;
        setDspYN(value);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (id) {
                    const { data } = await getMAGAT020(id);
                    setData({
                        type: data?.type || '',
                        title: data?.title || '',
                        content: data?.content || '',
                        agency: data?.agency || '',
                        url: data?.url || '',
                        urlTitle: data?.urlTitle || '',
                        ord: data?.ord || '',
                        dspYN: data?.dspYN || '',
                    });
                    setDspYN(data?.dspYN);
                    setFileName(data.fileName);
                }
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, [id]);

    return (
        <div id="content">
            <div className="container">
                <div className="compulsory-education content wrap">
                    <SideMenu menu={MENU_MENUS} />
                    <div className="compulsory-education-content content-right">
                        {!id ? (
                            <h1 className="title">법정의무교육 등록</h1>
                        ) : (
                            <h1 className="title">법정의무교육 수정</h1>
                        )}
                        <div id="compulsory-education-content-list">
                            <table className="table-gray">
                                <tbody>
                                    <tr>
                                        <th className="require">
                                            <span>구분 선택</span>
                                        </th>
                                        <td>
                                            <div className="select-box">
                                                <select name="type" value={data?.type} onChange={handleChange}>
                                                    <option value="WP">미이수 시 과태료가 있는 교육</option>
                                                    <option value="NP">미이수 시 과태료가 없는 교육</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="require">
                                            <span>교육명</span>
                                        </th>
                                        <td>
                                            <input
                                                type="text"
                                                name="title"
                                                placeholder="교육명 입력"
                                                value={data?.title}
                                                onChange={handleChange}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="require">
                                            <span>내용</span>
                                        </th>
                                        <td>
                                            <textarea
                                                id="contentTextarea"
                                                type="text"
                                                name="content"
                                                placeholder="내용 입력"
                                                value={data?.content}
                                                onChange={handleChange}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>출처</span>
                                        </th>
                                        <td>
                                            <input
                                                type="text"
                                                name="agency"
                                                placeholder="내용 입력"
                                                value={data?.agency}
                                                onChange={handleChange}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>교육자료</span>
                                        </th>
                                        <td>
                                            <div className="group-input-file">
                                                <input type="text" placeholder="파일 등록" value={fileName} disabled />
                                                <input type="file" id="file-input" onChange={handleFileChange} />
                                                <label htmlFor="file-input">파일 첨부</label>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>관련링크 URL</span>
                                        </th>
                                        <td>
                                            <input
                                                type="text"
                                                name="url"
                                                placeholder=""
                                                value={data?.url}
                                                onChange={handleChange}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <span>관련링크 정보</span>
                                        </th>
                                        <td>
                                            <textarea
                                                type="text"
                                                name="urlTitle"
                                                placeholder=""
                                                value={data?.urlTitle}
                                                onChange={handleChange}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <span>순서</span>
                                        </th>
                                        <td>
                                            <input
                                                type="number"
                                                name="ord"
                                                value={data?.ord}
                                                onChange={handleChange}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <th className="require">
                                            <span>공개여부</span>
                                        </th>
                                        <td>
                                            <div className="checkbox-group">
                                                <fieldset id="dspYN" className="radio-group">
                                                    <div className="item-radioBox">
                                                        <input
                                                            type="radio"
                                                            name="dspYN"
                                                            value="Y"
                                                            id="dpsY"
                                                            checked={dspYN === 'Y'}
                                                            onChange={handleChangeDsp}
                                                        />
                                                        <span />
                                                        <label htmlFor="dpsY">
                                                            <span>공개</span>
                                                        </label>
                                                    </div>
                                                    <div className="item-radioBox">
                                                        <input
                                                            type="radio"
                                                            name="dspYN"
                                                            value="N"
                                                            id="dpsN"
                                                            checked={dspYN === 'N'}
                                                            onChange={handleChangeDsp}
                                                        />
                                                        <span />
                                                        <label htmlFor="dpsN">
                                                            <span>비공개</span>
                                                        </label>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div className="bottom-content">
                                <Link to="/magat010" className="button-back-to-list">
                                    목록
                                </Link>
                                <button className="button-save" onClick={handleSave}>
                                    등록/수정
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAGAT020;
